<template>
  <div class="user-info-container">
    <el-card>
      <template #header>
        <span>修改密码</span>
      </template>
      <el-form 
        :model="form" 
        :rules="rules" 
        ref="formRef"
        label-width="120px"
        @submit.prevent="submitForm"
      >
        <el-form-item label="当前密码" prop="currentPassword">
          <el-input 
            v-model="form.currentPassword" 
            type="password" 
            show-password
            placeholder="请输入当前密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input 
            v-model="form.newPassword" 
            type="password" 
            show-password
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input 
            v-model="form.confirmPassword" 
            type="password" 
            show-password
            placeholder="请再次输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm">提交</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { reactive, ref } from 'vue'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'

export default {
  setup() {
    const form = reactive({
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    })

    const formRef = ref(null)
    const store = useStore()
    const router = useRouter()

    const validatePass = (rule, value, callback) => {
      console.log('Validating password:'+value+" newPassword:"+form.newPassword)
      if (value !== form.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    const rules = {
      currentPassword: [
        { required: true, message: '请输入当前密码', trigger: 'blur' }
      ],
      newPassword: [
        { required: true, message: '请输入新密码', trigger: 'blur' },
        { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
      ],
      confirmPassword: [
        { required: true, message: '请确认新密码', trigger: 'blur' },
        { validator: validatePass, trigger: 'blur' }
      ]
    }

    const submitForm = () => {
      formRef.value.validate(valid => {
        if (valid) {
          store.dispatch('updatePassword', {
            currentPassword: form.currentPassword,
            password: form.newPassword
          }).then(() => {
            ElMessage.success('密码修改成功')
            store.dispatch('logout').then(() => {
              router.push('/login')
            })
          }).catch(error => {
            ElMessage.error(error.message || '密码修改失败')
          })
        }
      })
    }

    const resetForm = () => {
      formRef.value.resetFields()
    }

    return {
      form,
      rules,
      formRef,
      submitForm,
      resetForm
    }
  }
}
</script>

<style scoped>
.user-info-container {
  padding: 20px;
}
</style>